(function() {
  'use strict';

  angular
    .module('pub.profile.service', [])
    .factory('ProfileService', ProfileService);

  /** @ngInject */
  function ProfileService($http, $q, API) {

    function get(){
        var defered = $q.defer();

        $http.get(API.API_URL + 'users/me')
          .success(defered.resolve);

        return defered.promise;
    }

    function update(model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'users/me', model)
          .success(defered.resolve);

        return defered.promise;
    }

    function changePassword(model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'users/password', model)
          .success(defered.resolve);

        return defered.promise;
    }

    return{
        update: update,
        get: get,
        changePassword: changePassword
    };

  }

})();
